export const validateAddresses = (formData) => {
    if (canShowSchoolsManualAddress(formData)
        && formData.currentAddressInfo.id
        && formData.permanentAddressInfo.id) {
        return true;
    }

    return false;
}

export const validateWishes = (formData) => {
    if (formData.wishes.every(x => x.school !== '' && x.school !== null)) {
        return true;
    }

    return false;
}

export const canShowSchoolsManualAddress = (formData) => {
    if (formData.permanentAddress.id &&
        formData.currentAddress.id &&
        formData.permanentAddressDate &&
        formData.currentAddressDate) {
        return true;
    }

    return false;
}

export const canShowSchoolsAddressResidence = (formData) => {
    if (formData.childIsEgn == '0' && formData.currentAddress) {
        return true;
    } else if (formData.childIsEgn == '1' && formData.permanentAddress && formData.currentAddress) {
        return true;
    }

    return false;
}

export const canShowAdditionalInfo = (formData) => {
    if (formData.wishes[0].school) {
        return true;
    }

    return false;
}

export const validateTwin = (formData, twinEgn, index) => {

    const newTwins = [...formData.twins.slice(0, index), ...formData.twins.slice(index + 1)];
    const childEgnFirstSix = formData.childEgn.substring(0, 6);

    if (newTwins.some(x => x.twinEgn == twinEgn)) {
        return 'Не може да добавите близнаци с еднакво ЕГН/ЛНЧ!';
    } else if (formData.twins.some(x => x.twinEgn == formData.childEgn)) {
        return 'Внимание! Дублирано ЕГН/ЛНЧ при близнаци';
    } else if (formData.twins.some(x => x.twinEgn.substring(0, 6) !== childEgnFirstSix) && formData.twins[index].twinIsEgn == '1') {
        return 'Некоректни данни: ЕГН на близнак';
    }

    return null;
}

export const validateDublicateChildrenNames = (formData) => {

    const hasDuplicateNames = formData.twins.some((twin, index) => {
        return formData.twins.some((otherTwin, otherIndex) => {
            return index !== otherIndex && twin.twinName === otherTwin.twinName && twin.twinName !== '';
        });
    });

    if (hasDuplicateNames) {
        return 'Имате близнаци с дублирани имена!'
    } else if (formData.twins.some(x => x.twinName == formData.childName)) {
        return 'Не може първото дете и близнаците да са с еднакви имена!'
    }

    return null;
}

export const validateLnchYearsFromSelectedDate = (selectedBirthDate, priemYear) => {
    if (selectedBirthDate == null) {
        return true;
    }

    const currentDate = new Date();

    const yearsDifference = Number(priemYear) - selectedBirthDate.getFullYear();

    if (yearsDifference >= 6 && yearsDifference <= 8) {
        return true;

    } else {
        return false;
    }
}

export const passRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
